import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../../contexts';
import { Attempt } from '../../hooks/useDashboard';

interface Props { attempts: Attempt[]; }

const AttemptsList: React.FC<Props> = ({ attempts }) => {
  const { t, i18n } = useTranslation();
  const { isRTL } = useLanguage();
  const navigate = useNavigate();

  if (attempts.length === 0) {
    return (
      <div className="bg-white rounded-xl shadow p-6 text-center text-gray-400" dir={isRTL ? 'rtl' : 'ltr'}>
        {t('dashboard.noAttempts')}
      </div>
    );
  }

  return (
    <div className="bg-white rounded-xl shadow-lg p-6" dir={isRTL ? 'rtl' : 'ltr'}>
      <h3 className="text-sm font-semibold text-gray-500 uppercase tracking-wide mb-4">
        {t('dashboard.previousAttempts')}
      </h3>
      <div className="space-y-3">
        {attempts.map(a => (
          <div
            key={a.id}
            onClick={() => a.status === 'completed' && navigate(`/results/${a.id}`)}
            className={`flex justify-between items-center p-3 rounded-lg border transition ${
              a.status === 'completed'
                ? 'border-gray-200 hover:border-primary cursor-pointer'
                : 'border-gray-100 bg-gray-50'
            } ${isRTL ? 'flex-row-reverse' : ''}`}
          >
            <div>
              <p className="font-medium text-gray-800 text-sm">
                {t(`languages.${a.language}`)} {a.language === 'french' ? '🇫🇷' : a.language === 'arabic' ? '🇩🇿' : '🇬🇧'}
              </p>
              <p className="text-xs text-gray-400">
                {new Date(a.started_at).toLocaleDateString(i18n.language === 'ar' ? 'ar' : i18n.language === 'fr' ? 'fr-FR' : 'en-US', {
                  day: '2-digit', month: 'long', year: 'numeric'
                })}
              </p>
            </div>
            <div className={`text-right ${isRTL ? 'text-left' : ''}`}>
              {a.status === 'completed' && a.raw_score !== null ? (
                <>
                  <p className="font-bold text-primary">{a.raw_score}/40</p>
                  <p className="text-xs text-gray-400">{a.profile_type}</p>
                </>
              ) : (
                <span className="text-xs text-amber-500 font-medium">{t('dashboard.ongoing')}</span>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AttemptsList;
